// extracted by mini-css-extract-plugin
export var resizer = "_gj-0";